/**
 * useManosMarketing — resolves whether the Manos marketing treatment (F7) should mount.
 *
 * Fetches the public flag CF (ADR-059-addendum-003) on mount. Fail-closed: while loading
 * and on any error, `enabled` is false (better not to flash crisis chrome than to flash it
 * then hide it). `enabled` is master AND `marketing` — the CF already master-gates surfaces,
 * so a true `marketing` field already implies master on.
 */
import { useEffect, useState } from 'react';
import { fetchManosFlags } from '../lib/manosFlags';

export interface UseManosMarketingResult {
  loading: boolean;
  enabled: boolean;
}

export function useManosMarketing(): UseManosMarketingResult {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    fetchManosFlags(controller.signal)
      .then((flags) => {
        if (active) setEnabled(flags.marketing === true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  return { loading, enabled };
}
